import { freddyTheme, type SxProps } from '@coolblue-development/freddy';

export const comparisonColumnStyles: SxProps = {
  display: 'inline-block',
  whiteSpace: 'normal',
  padding: `1rem 0 1rem ${freddyTheme.spacing[400]}`,

  '&:first-of-type, &:nth-of-type(2)': {
    paddingLeft: 0
  },

  [freddyTheme.breakpoint.only('md')]: {
    '&:nth-of-type(2)': {
      paddingLeft: freddyTheme.spacing[600]
    }
  }
};
